const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('1NN3652FSN', 'a4523729cafa8e84dcdb2f7f78ecce86');
let indexDefault = 'sifrei_yesod', indexSearchBox = 'sifrei_yesod_search', sifreiForms = document.querySelectorAll('.sifrei-form'), letterOrder = document.getElementById('letter-order'), clearBtns = document.querySelectorAll('.all-clear'), search, isSortingFixed = true, lastQuery = '';
/*function esTrigger(el, eventType) {
    if (typeof eventType === 'string' && typeof el[eventType] === 'function') {
        el[eventType]();
    } else {
        const event =
            typeof eventType === 'string'
                ? new Event(eventType, {bubbles: true})
                : eventType;
        el.dispatchEvent(event);
    }
}*/ function zoom(e) {
    var zoomer = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
    x = offsetX / zoomer.offsetWidth * 100;
    y = offsetY / zoomer.offsetHeight * 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
}
function switchIndexAndRestartSearch(search, newIndex, query = '') {
    if (search) search.dispose();
    initSearch(newIndex, query);
}
function resetFilterParameters(helper) {
    helper.clearRefinements();
    helper.setQueryParameter('numericFilters', undefined);
    helper.setQueryParameter('facetFilters', undefined);
    helper.setQueryParameter('facets', undefined);
    helper.setQueryParameter('filters', undefined);
    if (helper.getIndex() !== 'sifrei_yesod') helper.setIndex('sifrei_yesod');
}
function resetSidebarFilters(helper) {
    console.log("reset sidebar filters", helper);
    const filterForms = document.querySelectorAll('form[id^="sifrei-form"]');
    filterForms.forEach((form)=>{
        form.querySelectorAll('[data-field]').forEach((input)=>{
            if (input.tagName === 'SELECT') input.selectedIndex = 0;
            else input.value = '';
        });
    });
    document.querySelectorAll('.ais-RefinementList-item--selected .ais-RefinementList-checkbox').forEach((checkbox)=>checkbox.click());
    resetFilterParameters(helper);
}
function resetAlpabetFilter() {
    // 3. Сброс сортировки
    document.querySelectorAll('.sort-link.active').forEach((link)=>{
        link.classList.remove('active', 'asc', 'desc');
    });
    // 4. Сброс первой буквы
    document.querySelectorAll('[data-letter].active').forEach((link)=>{
        link.classList.remove('active');
        document.getElementById('letter-default-order').classList.add('active');
    });
    if (search.helper.getIndex() !== 'sifrei_yesod') search.helper.setIndex('sifrei_yesod');
}
function resetSearchBox() {
    // 7. Очистить поисковую строку
    const searchInput = document.querySelector('.ais-SearchBox-input');
    if (searchInput) searchInput.value = '';
    search.helper.setQuery('');
    console.log("reset search box", searchInput.value);
    if (search.helper.getIndex() !== 'sifrei_yesod') search.helper.setIndex('sifrei_yesod');
}
function resetAllFilters() {
    // 1. Очистить все формы
    const filterForms = document.querySelectorAll('form[id^="sifrei-form"]');
    filterForms.forEach((form)=>{
        form.querySelectorAll('[data-field]').forEach((input)=>{
            if (input.tagName === 'SELECT') input.selectedIndex = 0;
            else input.value = '';
        });
    });
    // 2. Сбросить выбранные категории (checkbox / select)
    document.querySelectorAll('.ais-RefinementList-item--selected .ais-RefinementList-checkbox').forEach((checkbox)=>checkbox.click());
    resetAlpabetFilter();
    // 5. Сброс состояния поиска
    search.addWidgets([
        instantsearch.widgets.configure({
            filters: '',
            numericFilters: []
        })
    ]);
    // 6. Сброс индекса на базовый
    if (search.helper.getIndex() !== 'sifrei_yesod') search.helper.setIndex('sifrei_yesod');
    resetSearchBox();
    // 8. Выполнить поиск
    search.helper.setQuery('').search();
}
const TemplateHelper = {
    idPrint: (id, number)=>{
        return number;
    },
    generateElements: (html)=>{
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.children;
    },
    parents: (el, selector)=>{
        const parents = [];
        while((el = el.parentNode) && el !== document)if (!selector || el.matches(selector)) parents.unshift(el);
        return parents;
    },
    trigger: (el, eventType)=>{
        if (typeof eventType === 'string' && typeof el[eventType] === 'function') el[eventType]();
        else {
            const event = eventType === 'string' ? new Event(eventType, {
                bubbles: true
            }) : eventType;
            el.dispatchEvent(event);
        }
    },
    yearCheckerStr: (year0, year1)=>{
        let str = "";
        if (year0.length > 0) str += year0;
        if (year1.length > 0) str += " - " + year1;
        return str;
    },
    yearChecker: (year0, year1)=>{
        let str = "";
        if (parseInt(year0) > 0) str += year0;
        if (parseInt(year1) > 0) str += " - " + year1;
        return str;
    },
    emptyIcon: ()=>{
        return "";
    },
    letterPrinter: (node)=>{
        const letters = "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DB\u05DA\u05DC\u05DE\u05DD\u05E0\u05DF\u05E1\u05E2\u05E4\u05E3\u05E6\u05E5\u05E7\u05E8\u05E9\u05EA".split('');
        node.innerHTML = `<th><a href="#" data-letter="">\u{5D4}\u{5DB}\u{5DC}</a></th>`;
        letters.forEach((letter)=>{
            node.innerHTML += `<th><a href="#" data-letter="${letter}">${letter}</a></th>`;
        });
    }
};
function buildSafeFilters(inputs) {
    const filterStrings = [];
    const numericFilters = [];
    for (const input of inputs){
        const name = input.name;
        const value = input.value.trim();
        const attr = input.getAttribute('data-field');
        const classes = input.classList;
        if (!value) continue;
        if (classes.contains('filter-field')) {
            // Строковые фильтры, экранируем кавычки и добавляем ""
            const safeValue = value.replace(/"/g, '\\"');
            filterStrings.push(`${attr}:"${safeValue}"`);
        }
        if (classes.contains('year_field')) {
            const num = parseInt(value, 10);
            if (!isNaN(num)) {
                if (name === 'min') numericFilters.push(`meta.${attr} >= ${num}`);
                else if (name === 'max') numericFilters.push(`meta.${attr} <= ${num}`);
            }
        }
    }
    const filters = filterStrings.length ? filterStrings.join(' AND ') : '';
    return {
        filters,
        numericFilters
    };
}
function initSearch(indexName, initialQuery = '') {
    search = instantsearch({
        indexName: indexName,
        searchClient,
        future: {
            preserveSharedStateOnUnmount: true
        },
        initialUiState: {
            [indexName]: {
                query: initialQuery
            }
        },
        //
        exactOnSingleWordQuery: 'word'
    });
    let queryHook = (query, searchFn)=>{
        const trimmed = query.trim();
        const newIndex = trimmed.length > 2 ? 'sifrei_yesod_search' : 'sifrei_yesod';
        console.log("base", newIndex, query);
        if (search.helper.state.index !== newIndex) {
            resetSidebarFilters(search.helper);
            search.helper.setIndex(newIndex);
        }
        searchFn(trimmed);
    };
    let searchBoxConfig = {
        container: '#searchbox',
        /*typoTolerance: 'min',
        minWordSizefor1Typo: 5,
        minWordSizefor2Typos: 8,
        ignorePlurals: false,
        removeWordsIfNoResults: 'none',
        queryType: 'prefixNone',*/ queryHook
    };
    if (window.matchMedia("(max-width: 767px)").matches) {
        queryHook = (query, searchFn)=>{
            const trimmed = query.trim();
            lastQuery = trimmed;
            const newIndex = trimmed.length > 2 ? 'sifrei_yesod_search' : 'sifrei_yesod';
            if (newIndex !== indexDefault) indexDefault = newIndex;
            document.addEventListener('click', function(e) {
                if (e.target.closest('.mobile-submit')) {
                    e.preventDefault();
                    const input = document.querySelector('.mobile-input');
                    if (input) {
                        const query = input.value.trim();
                        if (search && query !== '') {
                            lastQuery = query;
                            console.log(indexDefault, newIndex);
                            switchIndexAndRestartSearch(search, newIndex, lastQuery);
                        }
                    }
                }
            });
            document.addEventListener('click', function(e) {
                if (e.target.closest('.mobile-reset')) {
                    e.preventDefault();
                    const input = document.querySelector('.mobile-input');
                    if (input) {
                        const query = input.value.trim();
                        if (search && query !== '') {
                            lastQuery = query;
                            console.log(indexDefault);
                            switchIndexAndRestartSearch(search, 'sifrei_yesod');
                        }
                    }
                }
            });
        };
        searchBoxConfig = {
            container: '#searchbox',
            autofocus: true,
            showReset: true,
            showSubmit: true,
            showLoadingIndicator: true,
            queryHook,
            templates: {
                reset: '<svg class="ais-SearchBox-resetIcon" viewBox="0 0 20 20" width="10" height="10" aria-hidden="true"><path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path></svg>',
                submit: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/></svg>',
                loadingIndicator: '<span class="loading">\u23F3</span>'
            },
            cssClasses: {
                root: 'mobile-searchbox',
                input: 'mobile-input',
                reset: 'mobile-reset',
                submit: 'mobile-submit',
                loadingIndicator: 'mobile-loading'
            }
        };
    }
    if (!!document.getElementById('searchbox')) search.addWidgets([
        instantsearch.widgets.searchBox(searchBoxConfig),
        /*instantsearch.widgets.clearRefinements({
                container: '#clear-refinements',
            }),*/ instantsearch.widgets.voiceSearch({
            container: '#voicesearch',
            language: 'he-IL'
        }),
        instantsearch.widgets.hits({
            container: '#hits',
            language: 'he-IL',
            templates: {
                item: (hit, { html, components })=>html`
                    <div class="syc-item">
                        <div class="syc-item-block syc-item__img syc-head__img">
                            <img src=${hit.thumbnail} alt=${hit.book.post_title} />
                        </div>
                        <!-- Book name -->
                        <div class="syc-item-block syc-item__title syc-head__title">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${components.Highlight({
                        hit,
                        attribute: "book.post_title"
                    })}</a>
                        </div>
                        <!-- Author name -->
                        <div class="syc-item-block syc-item__author syc-head__author">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${components.Highlight({
                        hit,
                        attribute: "terms.author.name"
                    })}
                            </a>
                        </div>
                        <!-- Printing place -->
                        <div class="syc-item-block syc-item__location syc-head__location">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${components.Highlight({
                        hit,
                        attribute: "terms.printing_place.name"
                    })}
                            </a>
                        </div>
                        <!-- Hebrew year -->
                        <div class="syc-item-block syc-item__year-hebrew syc-head__year-hebrew">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${TemplateHelper.yearCheckerStr(hit.meta.hebrew_year, hit.meta.hebrew_year_2)}
                            </a>
                        </div>
                        <!-- English year -->
                        <div class="syc-item-block syc-item__year syc-head__year">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${TemplateHelper.yearChecker(hit.meta.english_year, hit.meta.english_year_2)}
                            </a>
                        </div>
                        <!-- Number -->
                        <div class="syc-item-block syc-item__number syc-head__number">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${TemplateHelper.idPrint(hit.meta.id, hit.meta.yesod_number)}
                            </a>
                        </div>
                        <div class="syc-item-block syc-item__category syc-head__category">
                            <a class="#" data-bs-toggle="collapse" href="#collapse-${hit.book.ID}" role="button" aria-expanded="false" aria-controls="collapse-${hit.book.ID}">
                                ${components.Highlight({
                        hit,
                        attribute: "terms.yesod_category.name"
                    })}
                            </a>
                        </div>
                        <div class="syc-item__empty-0"></div>
                        <div class="syc-item__content accordion-collapse collapse" id="collapse-${hit.book.ID}" data-bs-parent="#hits">
                            <!-- Content -->
                            <div class="syc-item__content__inner">
                                <div class="syc-item__content__img">
                                    <figure class="zoom" style="background-image:url(${hit.image});">
                                        <img id="zoomImg" class="syc-zoomImg" src=${hit.image} alt=${hit.book.post_title} loading="lazy" />
                                    </figure>
                                </div>
                                <div class="syc-item__content__text">
                                    <div class="title">מידע נוסף</div>
                                    ${hit.meta.info_page_count ? html`
                                        <div class="description description__page_count">
                                            <svg class="icon">
                                                <use xlink:href="#info"></use>
                                            </svg>
                                            <div class="description__inner">
                                                <pre>${components.Highlight({
                        hit,
                        attribute: "meta.info_page_count"
                    })}</pre>
                                            </div>
                                        </div>` : ""}
                                    ${hit.book.post_content ? html`
                                        <div class="description description__content">
                                            <svg class="icon">
                                                <use xlink:href="#page-count"></use>
                                            </svg>
                                            <div class="description__inner">
                                                <pre>${components.Highlight({
                        hit,
                        attribute: "book.post_content"
                    })}</pre>
                                            </div>
                                        </div>` : ""}
                                    ${hit.meta.info_plus ? html`
                                        <div class="description description__info_plus">
                                            <svg class="icon"><use xlink:href="#plus"></use></svg>
                                            <div class="description__inner">
                                                <pre>${components.Highlight({
                        hit,
                        attribute: "meta.info_plus"
                    })}</pre>
                                            </div>
                                        </div>` : ""}
                                    ${hit.meta.first ? html`
                                        <div class="description description__first">
                                            <svg class="icon">
                                                <use xlink:href="#first"></use>
                                            </svg>
                                            <div class="description__inner">
                                                <pre>${components.Highlight({
                        hit,
                        attribute: "meta.first"
                    })}</pre>
                                            </div>
                                        </div>` : ""}
                                    ${hit.meta.kolofon !== "" ? html`
                                        <div class="description description__kolofon">
                                            <svg class="icon"><use xlink:href="#kolofon"></use></svg>
                                            <div class="description__inner">
                                                <pre>${components.Highlight({
                        hit,
                        attribute: "meta.kolofon"
                    })}</pre>
                                            </div>
                                        </div>` : ""}
                                </div>
                            </div>
                        </div>
                        <div class="syc-item__empty-1"></div>
                        <div class="syc-item__empty-2"></div>
                    </div>
                `,
                empty: `
                    <div class="no-results">
                        <p>\u{5E1}\u{5E4}\u{5E8} \u{5D6}\u{5D4} \u{5D0}\u{5D9}\u{5E0}\u{5D5} \u{5D1}\u{5DE}\u{5D0}\u{5D2}\u{5E8} \u{5E1}\u{5E4}\u{5E8}\u{5D9} \u{5D9}\u{5E1}\u{5D5}\u{5D3}</p>
                    </div>
                `
            }
        }),
        instantsearch.widgets.configure({
            hitsPerPage: 50,
            // exactOnSingleWordQuery: 'word',
            // Strict search
            typoTolerance: 'min',
            minWordSizefor1Typo: 5,
            minWordSizefor2Typos: 8,
            ignorePlurals: false,
            removeWordsIfNoResults: 'none',
            queryType: 'prefixNone'
        }),
        instantsearch.widgets.pagination({
            container: '#pagination'
        })
    ]);
    if (!!document.querySelector('.ais-SearchBox.mobile-searchbox .ais-SearchBox-form')) document.querySelector('.ais-SearchBox.mobile-searchbox .ais-SearchBox-form').addEventListener('submit', (event)=>{
        event.preventDefault();
        search.helper.setQuery(lastQuery).search();
    });
    search.start();
    return search;
}
document.addEventListener("DOMContentLoaded", function(event) {
    search = initSearch(indexDefault);
    console.log("begin");
    let yesodCategoriesIsBuild = false;
    search.addWidgets([
        instantsearch.widgets.refinementList({
            container: '#categories',
            attribute: 'terms.yesod_category.name',
            cssClasses: {
                list: 'ais-RefinementList-list yesod_category'
            },
            transformItems (items) {
                setTimeout(()=>{
                    const parent = document.querySelector('#categories');
                    if (parent && !parent.querySelector('select')) {
                        const select = document.createElement('select');
                        select.id = 'categories-input';
                        select.setAttribute("data-field", "terms.yesod_category.name");
                        select.classList.add('form-select');
                        select.classList.add('filter-field');
                        select.innerHTML = '<option value="">\u05D1\u05D7\u05E8</option>';
                        items.forEach((item)=>{
                            const option = document.createElement('option');
                            option.value = item.value;
                            option.textContent = item.label;
                            if (item.isRefined) option.selected = true;
                            select.appendChild(option);
                        });
                        /*select.addEventListener('change', (e) => {
                            const val = e.target.value;
                            search.helper.clearRefinements('terms.yesod_category.name');
                            if (val) {
                                search.helper.addDisjunctiveFacetRefinement('terms.yesod_category.name', val).search();
                            } else {
                                search.helper.search();
                            }
                        });*/ parent.innerHTML = '';
                        parent.appendChild(select);
                    }
                }, 0);
                return items;
            }
        }),
        instantsearch.widgets.refinementList({
            container: '#categories-2',
            attribute: 'terms.yesod_category.name',
            cssClasses: {
                list: 'ais-RefinementList-list yesod_category'
            },
            transformItems (items) {
                setTimeout(()=>{
                    const parent = document.querySelector('#categories-2');
                    if (parent && !parent.querySelector('select')) {
                        const select = document.createElement('select');
                        select.id = 'categories-input';
                        select.setAttribute("data-field", "terms.yesod_category.name");
                        select.classList.add('form-select');
                        select.classList.add('filter-field');
                        select.innerHTML = '<option value="">\u05D1\u05D7\u05E8</option>';
                        items.forEach((item)=>{
                            const option = document.createElement('option');
                            option.value = item.value;
                            option.textContent = item.label;
                            if (item.isRefined) option.selected = true;
                            select.appendChild(option);
                        });
                        /*select.addEventListener('change', (e) => {
                            const val = e.target.value;
                            search.helper.clearRefinements('terms.yesod_category.name');
                            if (val) {
                                search.helper.addDisjunctiveFacetRefinement('terms.yesod_category.name', val).search();
                            } else {
                                search.helper.search();
                            }
                        });*/ parent.innerHTML = '';
                        parent.appendChild(select);
                    }
                }, 0);
                return items;
            }
        }),
        instantsearch.widgets.refinementList({
            container: '#authors',
            attribute: 'terms.author.name',
            cssClasses: {
                list: 'ais-RefinementList-list yesod_author'
            },
            transformItems (items) {
                setTimeout(()=>{
                    const parent = document.querySelector('#authors');
                    if (parent && !parent.querySelector('select')) {
                        const select = document.createElement('select');
                        select.id = 'authors-input';
                        select.setAttribute("data-field", "terms.author.name");
                        select.classList.add('form-select');
                        select.classList.add('filter-field');
                        select.innerHTML = '<option value="">\u05D1\u05D7\u05E8</option>';
                        items.forEach((item)=>{
                            const option = document.createElement('option');
                            option.value = item.value;
                            option.textContent = item.label;
                            if (item.isRefined) option.selected = true;
                            select.appendChild(option);
                        });
                        /*select.addEventListener('change', (e) => {
                            const val = e.target.value;
                            search.helper.clearRefinements('terms.author.name');
                            if (val) {
                                search.helper.addDisjunctiveFacetRefinement('terms.author.name', val).search();
                            } else {
                                search.helper.search();
                            }
                        });*/ parent.innerHTML = '';
                        parent.appendChild(select);
                    }
                }, 0);
                return items;
            }
        }),
        instantsearch.widgets.refinementList({
            container: '#authors-2',
            attribute: 'terms.author.name',
            cssClasses: {
                list: 'ais-RefinementList-list yesod_author'
            },
            transformItems (items) {
                setTimeout(()=>{
                    const parent = document.querySelector('#authors-2');
                    if (parent && !parent.querySelector('select')) {
                        const select = document.createElement('select');
                        select.id = 'authors-input';
                        select.setAttribute("data-field", "terms.author.name");
                        select.classList.add('form-select');
                        select.classList.add('filter-field');
                        select.innerHTML = '<option value="">\u05D1\u05D7\u05E8</option>';
                        items.forEach((item)=>{
                            const option = document.createElement('option');
                            option.value = item.value;
                            option.textContent = item.label;
                            if (item.isRefined) option.selected = true;
                            select.appendChild(option);
                        });
                        /*select.addEventListener('change', (e) => {
                            const val = e.target.value;
                            search.helper.clearRefinements('terms.author.name');
                            if (val) {
                                search.helper.addDisjunctiveFacetRefinement('terms.author.name', val).search();
                            } else {
                                search.helper.search();
                            }
                        });*/ parent.innerHTML = '';
                        parent.appendChild(select);
                    }
                }, 0);
                return items;
            }
        }),
        instantsearch.widgets.refinementList({
            container: '#places',
            attribute: 'terms.printing_place.name',
            cssClasses: {
                list: 'ais-RefinementList-list yesod_printing_place'
            },
            transformItems (items) {
                setTimeout(()=>{
                    const parent = document.querySelector('#places');
                    if (parent && !parent.querySelector('select')) {
                        const select = document.createElement('select');
                        select.id = 'places-input';
                        select.setAttribute("data-field", "terms.printing_place.name");
                        select.classList.add('form-select');
                        select.classList.add('filter-field');
                        select.innerHTML = '<option value="">\u05D1\u05D7\u05E8</option>';
                        items.forEach((item)=>{
                            const option = document.createElement('option');
                            option.value = item.value;
                            option.textContent = item.label;
                            if (item.isRefined) option.selected = true;
                            select.appendChild(option);
                        });
                        /*select.addEventListener('change', (e) => {
                            const val = e.target.value;
                            search.helper.clearRefinements('terms.printing_place.name');
                            if (val) {
                                search.helper.addDisjunctiveFacetRefinement('terms.printing_place.name', val).search();
                            } else {
                                search.helper.search();
                            }
                        });*/ parent.innerHTML = '';
                        parent.appendChild(select);
                    }
                }, 0);
                return items;
            }
        }),
        instantsearch.widgets.refinementList({
            container: '#places-2',
            attribute: 'terms.printing_place.name',
            cssClasses: {
                list: 'ais-RefinementList-list yesod_printing_place'
            },
            transformItems (items) {
                setTimeout(()=>{
                    const parent = document.querySelector('#places-2');
                    if (parent && !parent.querySelector('select')) {
                        const select = document.createElement('select');
                        select.id = 'places-input';
                        select.setAttribute("data-field", "terms.printing_place.name");
                        select.classList.add('form-select');
                        select.classList.add('filter-field');
                        select.innerHTML = '<option value="">\u05D1\u05D7\u05E8</option>';
                        items.forEach((item)=>{
                            const option = document.createElement('option');
                            option.value = item.value;
                            option.textContent = item.label;
                            if (item.isRefined) option.selected = true;
                            select.appendChild(option);
                        });
                        /*select.addEventListener('change', (e) => {
                            const val = e.target.value;
                            search.helper.clearRefinements('terms.printing_place.name');
                            if (val) {
                                search.helper.addDisjunctiveFacetRefinement('terms.printing_place.name', val).search();
                            } else {
                                search.helper.search();
                            }
                        });*/ parent.innerHTML = '';
                        parent.appendChild(select);
                    }
                }, 0);
                return items;
            }
        })
    ]);
    search.on('render', ()=>{
        let zoomFeatureItems = document.querySelectorAll('figure.zoom'), yesodCategoriesBox = document.getElementById('categories'), yesodCategories = document.querySelector('.ais-RefinementList-list.yesod_category');
        if (zoomFeatureItems.length > 0) zoomFeatureItems.forEach(function(elem, index) {
            elem.addEventListener('mousemove', function(event) {
                zoom(event);
            });
        });
        if (!!yesodCategories && !yesodCategoriesIsBuild) {
            let items = yesodCategories.querySelectorAll(`:scope .ais-RefinementList-link`);
            if (items.length > 0) {
                const selectElem = TemplateHelper.generateElements('<select multiple class="form-select"><option>Select value</option></select>')[0];
                items.forEach(function(elem, index) {
                    selectElem.options[selectElem.options.length] = new Option(elem.innerHTML, elem.getAttribute('href'));
                });
                yesodCategoriesBox.append(selectElem);
                yesodCategoriesIsBuild = true;
                selectElem.addEventListener('change', function(event) {
                    let val = this.value;
                    let active = yesodCategories.querySelector(`:scope .ais-RefinementList-link[href='${val}']`);
                    TemplateHelper.trigger(active, 'click');
                });
            }
        }
        document.querySelectorAll('.syc-head__number .sort-link').forEach((link)=>{
            if (indexDefault === indexSearchBox) link.classList.remove('active');
            else if (link.classList.contains('desc')) link.classList.add('active');
        });
    });
    document.getElementById('filter-button').addEventListener('click', (event)=>{
        event.preventDefault();
        const form = document.getElementById('sifrei-form-desktop');
        const inputs = form.querySelectorAll('[data-field]');
        const query = buildSafeFilters(inputs);
        resetFilterParameters(search.helper);
        resetAlpabetFilter();
        resetSearchBox();
        console.log(query, inputs, form);
        search.addWidgets([
            instantsearch.widgets.configure({
                filters: query.filters,
                numericFilters: query.numericFilters
            })
        ]);
        search.refresh();
    });
    document.getElementById('filter-button-mobile').addEventListener('click', (event)=>{
        event.preventDefault();
        const form = document.getElementById('sifrei-form-mobile');
        const inputs = form.querySelectorAll('[data-field]');
        const query = buildSafeFilters(inputs);
        resetFilterParameters(search.helper);
        resetAlpabetFilter();
        resetSearchBox();
        console.log(query, inputs, form);
        search.addWidgets([
            instantsearch.widgets.configure({
                filters: query.filters,
                numericFilters: query.numericFilters
            })
        ]);
        search.refresh();
    });
    // Сортировка
    if (indexDefault !== indexSearchBox) document.querySelectorAll('.sort-link').forEach((link)=>{
        link.addEventListener('click', (event)=>{
            event.preventDefault();
            let sortIndex = event.target.getAttribute('data-sort');
            document.querySelectorAll('.sort-link').forEach(function(elem, index) {
                console.log(elem);
                elem.classList.remove('active');
            });
            resetFilterParameters(search.helper);
            resetAlpabetFilter();
            resetSearchBox();
            event.target.classList.add('active');
            if (event.target.classList.contains('asc')) {
                event.target.classList.remove('asc');
                event.target.classList.add('desc');
            } else {
                event.target.classList.remove('desc');
                event.target.classList.add('asc');
                sortIndex = sortIndex + "_desc";
            }
            console.log("Order:", sortIndex);
            search.helper.setIndex(sortIndex).search();
        });
    });
    search.on('render', ()=>{
        console.log('Widgets updated');
    });
    search.on('error', ()=>{
        console.log("error");
    });
    // Фикс для голосового поиска
    search.helper.on('change', (event)=>{
        if (isSortingFixed) {
            const query = search.helper.state.query || '';
            const trimmed = query.trim();
            const newIndex = trimmed.length > 2 ? 'sifrei_yesod_search' : 'sifrei_yesod';
            console.log("newIndex voice", newIndex);
            if (search.helper.state.index !== newIndex) //resetSidebarFilters(search.helper);
            search.helper.setIndex(newIndex).search();
        }
        isSortingFixed = false;
    });
    // Получаем элемент блока
    const floatingBlock = document.getElementById('floatingBlock');
    // Показываем блок при прокрутке
    window.addEventListener('scroll', ()=>{
        requestAnimationFrame(()=>{
            const scrolled = window.pageYOffset;
            const pageHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;
            // Проверка на видимость блока
            if (scrolled > 450) floatingBlock.classList.add('visible');
            else floatingBlock.classList.remove('visible');
            // Проверка на достижение конца страницы
            if (scrolled + windowHeight >= pageHeight - 400) floatingBlock.classList.add('at-bottom');
            else floatingBlock.classList.remove('at-bottom');
        });
    });
    // Сортировка по символу
    if (!!letterOrder) {
        let orderLinks = letterOrder.querySelectorAll('a');
        orderLinks.forEach(function(link, key) {
            link.addEventListener('click', function(event) {
                isSortingFixed = false;
                event.preventDefault();
                resetFilterParameters(search.helper);
                resetSidebarFilters(search.helper);
                resetSearchBox();
                orderLinks.forEach(function(link, key2) {
                    link.classList.remove('active');
                });
                const baseState = search.helper.state, $this = event.target;
                let letter = $this.getAttribute('data-letter');
                $this.classList.add('active');
                search.helper.setQuery(letter).setQueryParameter('restrictSearchableAttributes', [
                    'firstLetter'
                ]).search();
                search.helper.setState(baseState);
                isSortingFixed = false;
            });
        });
    }
    document.getElementById('reset-filters').addEventListener('click', resetAllFilters);
    document.getElementById('reset-filters-mobile').addEventListener('click', resetAllFilters);
    // Очистка фильтра
    /*if (!!clearBtns) {
        clearBtns.forEach(function (clearBtn, index) {
            clearBtn.addEventListener('click', function (event) {
                event.preventDefault();
                search.helper.setQueryParameter('restrictSearchableAttributes', '').search();
            });
        });
    }*/ const swiper = new Swiper('.sticky-slider.swiper', {
        speed: 400,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 3000
        }
    });
});

//# sourceMappingURL=index.17dcb6a6.js.map
